module.exports = __webpack_public_path__ + "img/MESTNA OBCINA SLOVENJ GRADEC.3e2f61a0.png";